"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.progressIcon = exports.completedIcon = exports.MedalIcon = exports.CompletedWrapper = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Medal = _interopRequireDefault(require("../../theme/icons/Medal"));

var _colors = _interopRequireDefault(require("../../theme/colors"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    color: ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    position: absolute;\n    left: calc(50% - 12px);\n    top: 46%;\n    color: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    position: absolute;\n    font-size: 72px;\n    color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  height: 72px;\n  width: 72px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var primaryColor = _colors["default"].orange[400];
var secondaryColor = _colors["default"].lychee[100];

var CompletedWrapper = _styledComponents["default"].div(_templateObject());

exports.CompletedWrapper = CompletedWrapper;

var MedalIconStripped = function MedalIconStripped(_ref) {
  var light = _ref.light,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["light"]);
  return /*#__PURE__*/_react["default"].createElement(_Medal["default"], props);
};

var MedalIcon = (0, _styledComponents["default"])(MedalIconStripped)(_templateObject2(), function (props) {
  return props.light ? secondaryColor : primaryColor;
});
exports.MedalIcon = MedalIcon;

var completedIcon = function completedIcon(icon, light) {
  return (0, _styledComponents["default"])(icon)(_templateObject3(), light ? primaryColor : secondaryColor);
};

exports.completedIcon = completedIcon;

var progressIcon = function progressIcon(icon, light) {
  return (0, _styledComponents["default"])(icon)(_templateObject4(), light ? secondaryColor : primaryColor);
};

exports.progressIcon = progressIcon;